import merge from 'lodash/merge';
import template from 'lodash/template';
import { DEFAULT_TRANSLATIONS, TranslationTypes } from './constants';

export function t(
  translatedStringKey,
  translationType = TranslationTypes.DEFAULT
) {
  return `\${${translatedStringKey}.${translationType}}`;
}

export function translateString(stringWithTemplateTokens, translations) {
  return template(stringWithTemplateTokens)(
    merge({}, DEFAULT_TRANSLATIONS, translations)
  );
}
